/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const caseMessagesStyle = {
  caseTitle: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    marginBottom: "1.5rem",
  },
  emptyState: {
    alignItems: "center",
    textAlign: "center",
    padding: "1.5rem 0",
  },
  emptyIcon: (fill?: string) => ({
    fill,
  }),
  emptyTitle: {
    margin: "1rem 0",
  },
  sortRowColumn: (theme: Theme) => ({
    borderBottom: "none",
    [theme.breakpoints.down("md")]: {
      padding: "1rem 0",
    },
  }),
  sortRowHidden: {
    display: {
      xs: "none",
      md: "table-cell",
    },
  },
  sortRowDate: {
    whiteSpace: "nowrap",
  },
  pagination: {
    alignItems: "center",
    margin: "1rem 0",
  },
  actionGrid: {
    justifyContent: "flex-end",
    paddingTop: "1rem",
  },
  actionEnd: {
    display: "flex",
    justifyContent: "flex-end",
  },
  actionLink: {
    display: "block",
    textAlign: "center",
    width: {
      xs: "100%",
      md: "auto",
    },
  },
};
